<template lang="pug">
b-modal#editSocialAccount(
  ref="editSocialAccount"
  :title="$t('ui.combine.edit_social_account')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.platform')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="social_platform"
        required
        type="text"
        v-model.trim.lazy="social_platform"
        :disabled="loading"
      )
    b-form-group(:label="$t('ui.link')").mb-0
      DebounceInput(
        size="sm"
        ref="social_link"
        type="text"
        v-model="social_link"
        :disabled="loading"
      )
      template(v-if="['facebook','instagram','skype','telegram','tiktok','wechat','whatsapp','youtube'].includes(social_platform.toLowerCase())")
        small.form-text.text-muted {{ $t('message.tooltips_social_' + social_platform.toLowerCase()) }}
      ValidateResult(:value="$v.social_link" :name="$t('ui.link')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      social_platform: "",
      social_link: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    social_link: {
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.accountSocialEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          social_platform: this.item.social_platform,
          social_link: this.social_link,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editSocialAccount.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_social_account", this.feedback.status);
                  this.$refs.editSocialAccount.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.social_platform = this.item.social_platform;
      this.social_link = this.item.social_link;
      this.$refs.social_link.$el.focus();
    }
  }
};
</script>
